export type Dir = 'ltr' | 'rtl';

export function getDir(): Dir {
  return document.body.dir as Dir;
}
